<template>
	<ListItem class="font-[Noto_Sans]" :title="language.name">
		<template v-if="userLanguage" #accessory>
			<select v-model="userLanguage.pivot.level" class="z-10" @click.stop="">
				<option v-for="level in LanguageLevel" :key="`language-${language.id}-level-${level}`" :value="level">{{ trans(`account.languages.levels.${level}`) }}</option>
			</select>
		</template>
		<template #accessory>
			<SoftButton v-if="userLanguage" :color="Color.Red" @click.stop="emit('toggleLanguage', language)">
				<i class="fa-solid fa-trash"/>
			</SoftButton>
			<SoftButton v-else :color="Color.Green" @click.stop="emit('toggleLanguage', language)">
				<i class="fa-solid fa-plus"/>
			</SoftButton>
		</template>
	</ListItem>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import ListItem from '@/Components/Lists/ListItem.vue'
import {type Language} from '@/Types/Settings/Language'
import {LanguageLevel} from '@/Types/Enums/LanguageLevel'
import {defineEmits, defineProps, ref, type Ref} from 'vue'
import SoftButton from '@/Components/Buttons/SoftButton.vue'

const props = defineProps<{
	language:Language,
	userLanguage?:Language,
}>()

const emit = defineEmits([
	'toggleLanguage',
])

const language:Ref<Language> = ref(props.language)
const userLanguage:Ref<Language|undefined> = ref(props.userLanguage)
</script>